import angular from 'angular';
import uiRouter from 'angular-ui-router';
import nestComponent from './nest.component';

let nestModule = angular.module('nest', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('nest', {
            url: '/nest',
            resolve: {
                currentData: (LoadedModel) => {
                    return LoadedModel.getCurrentSession();
                },
            },
            component: 'nest'
        });
})

.component('nest', nestComponent)

.name;




export default nestModule;



// WEBPACK FOOTER //
// ./client/app/components/nest/nest.js